export const enum DeleteStages {
  Initial = 'initial',
  Loading = 'loading',
  DenyDelete = 'denyDelete',
}
